import {v4 as uuid } from 'uuid';

export default function selectSchedulesByCategory (category) {
    this.categoryValue = category.value;
    const scheduleIds = category.scheduleIds;
    this.schedules = this.schedulesSources.filter((item) => {
        return scheduleIds.includes(item.id);
    });
    this.observed.categoryValue = uuid();
    this.observed.schedules = uuid();
}

export function selectSchedulesByCategoryData (category) {
    if (!category) return;

    const selectedCat = this.categories.filter((catItem) => catItem.value === category.value)[0];
    if (selectedCat.schedules) {
        this.schedules = selectedCat.schedules;
        this.observed.schedules = uuid();
    }
    this.categoryValue = category.value;
    this.observed.categoryValue = uuid();
}